module.exports = __webpack_public_path__ + "static/img/weibo_qrcode.d76c239.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weibo/weibo_qrcode.png
// module id = PDBX
// module chunks = 4